import { render, staticRenderFns } from "./ConfirmSaveMandates.vue?vue&type=template&id=b3301dee"
import script from "./ConfirmSaveMandates.vue?vue&type=script&lang=js"
export * from "./ConfirmSaveMandates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports